<template>
  <entity-list-table
    :title="title"
    :data-service="dataService"
    :headers="headers"
    :create-route-name="createRouteName"
    :edit-route-name="editRouteName"
    :allow-delete="allowDelete"
    :show-status-column="showStatusColumn"
  >
    <template #item.contractSignDate="{item}">
      {{ formatContractSignDate(item.contractSignDate) }}
    </template>
  </entity-list-table>
</template>

<script>
  import OrganizationDataService from '@/services/api/OrganizationDataService'
  import EntityListTable from '@/components/ui/crud/EntityListTable.vue'

  export default {
    components: { EntityListTable },
    data () {
      return {
        title: 'Организации (юр-лица)',
        dataService: OrganizationDataService,
        createRouteName: 'organizationCreate',
        editRouteName: 'organizationEdit',

        headers: [
          { text: 'ID', value: 'id', align: 'start' },
          { text: 'Название', value: 'name', align: 'start' },
          { text: 'Дата подписания договора', value: 'contractSignDate', align: 'center' },
        ],

        allowDelete: true,
        showStatusColumn: true,
      }
    },
    methods: {
      formatContractSignDate (date) {
        if (!date) { return '' }

        return new Date(date).toLocaleDateString(this.$i18n.locale, {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        })
      },
    },
  }
</script>
